// extracted by css-extract-rspack-plugin
export default {"fieldset":"PzN_S"};